import {createReducer} from "typesafe-actions";
import { FavoritesTree, FlatTree, Tree } from '../../../models/api/codegen/code';
import {
    CLEAR_TREE,
    clearLiveTree,
    clearRatingTree,
    getFavoritesTreeAsync,
    getAllTreeAsync,
    getTreeLiveAsync,
    getTreeRatingAsync,
    getTreeResultAsync,
    SET_RESULT_TAB
} from "../actions";

export const TreeInit: FlatTree = {
    l: [],
    h: 0,
    s: {},
    c: {},
    t: {},
    fixtures: {},
    v: 0,
    st: {s: true, p: false, l: false, f: []},
    m: {},
    f: [],
    ss: {},
    ms: {},
    alrds: []
}

const FavoritesTreeInit: FavoritesTree = {
    live: TreeInit,
    line: TreeInit,
    count: 0,
    v: 0,
    settings: {s: true, p: false, l: false, f: []},
    markets: {},
    fixtureWithMarkets: [],
    soccerStatistics: {},
    matchStatuses: {},
    alreadyStarted: []
};

export const favorites = createReducer<FavoritesTree>(FavoritesTreeInit)
    .handleAction(getFavoritesTreeAsync.success, (state, action) => action.payload)
    .handleAction(getAllTreeAsync.request, () => FavoritesTreeInit)
    .handleAction(getTreeResultAsync.request, () => FavoritesTreeInit)
    .handleAction(getTreeLiveAsync.request, () => FavoritesTreeInit)
    .handleAction(getTreeRatingAsync.request, () => FavoritesTreeInit);
    

export const line = createReducer<FlatTree>(TreeInit)
    .handleAction(getAllTreeAsync.success, (state, action) => action.payload)
    .handleAction(getTreeRatingAsync.request, () => TreeInit)
    .handleAction(getFavoritesTreeAsync.request, () => TreeInit)
    .handleAction(getTreeResultAsync.request, () => TreeInit)
    .handleAction(getTreeLiveAsync.request, () => TreeInit)
    .handleAction(CLEAR_TREE, () => TreeInit);

export const result = createReducer<FlatTree>(TreeInit)
    .handleAction(getTreeResultAsync.success, (state, action) => action.payload)
    .handleAction(getTreeRatingAsync.request, () => TreeInit)
    .handleAction(getFavoritesTreeAsync.request, () => TreeInit)
    .handleAction(getAllTreeAsync.request, () => TreeInit)
    .handleAction(getTreeLiveAsync.request, () => TreeInit)
    .handleAction(SET_RESULT_TAB, () => TreeInit);

export const live = createReducer<FlatTree>(TreeInit)
    .handleAction(getTreeLiveAsync.success, (state, action) => action.payload)
    .handleAction(getTreeRatingAsync.request, () => TreeInit)
    .handleAction(getFavoritesTreeAsync.request, () => TreeInit)
    .handleAction(getAllTreeAsync.request, () => TreeInit)
    .handleAction(getTreeResultAsync.request, () => TreeInit)
    .handleAction(clearLiveTree, () => TreeInit);

export const rating = createReducer<FlatTree>(TreeInit)
    .handleAction(getTreeRatingAsync.success, (state, action) => action.payload)
    .handleAction(getTreeLiveAsync.request, () => TreeInit)
    .handleAction(getFavoritesTreeAsync.request, () => TreeInit)
    .handleAction(getAllTreeAsync.request, () => TreeInit)
    .handleAction(getTreeResultAsync.request, () => TreeInit)
    .handleAction(clearRatingTree, () => TreeInit);

export const emptyTree = createReducer<FlatTree>(TreeInit);

